import {Box, Divider, Grid} from '@material-ui/core'
import _t, {_} from 'i18n'
import React, {useState} from 'react'
import {Button, Form} from 'react-bootstrap'
import ReactInputMask from 'react-input-mask'
import IntlCurrencyInput from 'react-intl-currency-input'

import {LabelM0} from '../../NewProposal/City/Details/styles'
import {Container, Title} from '../styles'

const categories = [
  {
    label: _`Implantação`,
    value: 'implantation',
  },
  {
    label: _`Expansão`,
    value: 'expansion',
  },
  {
    label: _`Reativação`,
    value: 'reactivation',
  },
  {
    label: _`Diversificação`,
    value: 'diversification',
  },
  {
    label: _`Busca por parceiros/investidores`,
    value: 'search_partner_investor',
  },
]

const ProposalDescription = ({project, handleChange, onSubmit, submiting, category}) => {
  return (
    <Container style={{padding: 0}}>
      <Grid container spacing={3}>
        <Grid item lg={3}>
          {' '}
        </Grid>
        <Grid item lg={9}>
          <Box marginBottom="20px">
            <Title>{_`DESCRIÇÃO DO PROJETO`}</Title>
          </Box>
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0 htmlFor="project_category">{_`Categoria da oportunidade`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <select
            className="form-control"
            name="project_category"
            id="project_category"
            value={project.category}
            onChange={handleChange}
            style={{maxWidth: 300}}>
            {categories.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0 htmlFor="project_total">{_`Valor total do investimento (R$)`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <IntlCurrencyInput
            autoComplete="off"
            placeholder={_`Ex.: R$ 800.000,00`}
            name="project_total"
            id="project_total"
            className="form-control"
            currency="BRL"
            style={{maxWidth: 600}}
            onChange={(ev, value) => handleChange({target: {value, name: 'project_total'}})}
            config={{
              locale: 'pt-BR',
              formats: {
                number: {
                  BRL: {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  },
                },
              },
            }}
            defaultValue={project.total}
          />
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0 htmlFor="project_required_investment">{_`Valor de necessidade do investimento (R$)`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <IntlCurrencyInput
            autoComplete="off"
            placeholder={_`Ex.: R$ 800.000,00`}
            name="project_required_investment"
            id="project_required_investment"
            className="form-control"
            currency="BRL"
            style={{maxWidth: 600}}
            onChange={(ev, value) => handleChange({target: {value, name: 'project_required_investment'}})}
            config={{
              locale: 'pt-BR',
              formats: {
                number: {
                  BRL: {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  },
                },
              },
            }}
            defaultValue={project.required_investment}
          />
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'baseline', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0 htmlFor="project_description">{_`Descrição do projeto`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <Form.Control
            autoComplete="off"
            name="project_description"
            id="project_description"
            as="textarea"
            onChange={handleChange}
            value={project.description}
            placeholder=""
            rows={5}
            style={{maxWidth: 600}}
          />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}></Grid>
        <Grid item lg={9}>
          <Box display="flex" marginTop="70px" marginBottom="70px">
            <Box mr="20px" style={{maxWidth: 300, width: '100%'}}>
              <Button variant="outline-primary" onClick={() => onSubmit(true)}>
                {_`SALVAR E CONTINUAR EDIÇÃO`}
              </Button>
            </Box>
            <Box>
              <Button onClick={() => onSubmit(false)} disabled={submiting}>
                {_`SALVAR E CONCLUIR EDIÇÃO`}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}

export default ProposalDescription
